export default __webpack_public_path__ + "static/media/right.eed3c480.png";